import {Expressions} from '@packages/systems/wfdl';
import {
  type Expression,
  type ExpressionElement,
} from '@packages/systems/wfdl-ast';
import {emptyArray} from '@packages/utilities/fp/utils';

export function getStyleBlockIds(element: ExpressionElement): string[] {
  const styleBlockIds = Expressions.getIn(Expressions.getElementData(element), [
    {in: 'Record', at: 'styleBlockIds'},
  ]);
  const styleBlockIdsList = styleBlockIds
    ? Expressions.getList(styleBlockIds)
    : null;

  if (styleBlockIdsList) {
    return styleBlockIdsList.reduce<Array<string>>(
      (memo: string[], expr: Expression) => {
        const text = Expressions.getText(expr);
        if (text) {
          memo.push(text);
        }
        return memo;
      },
      []
    );
  }

  return emptyArray;
}
